
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { quillEditor } from 'vue-quill-editor'
import { IMG_HOST } from '@/config/env'
import UploadImg from '@/components/upload_img/index.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

@Component({
    name: 'Editor',
    components: {
        quillEditor,
        UploadImg
    }
})

/**
 * 
 * @prop content        内容
 * @prop changeCb       内容改变回调
 * @prop image          使用配置 option 的图片按钮
 * @prop placeholder    输入框提示语
 * @prop error          是否错误
 * 
*/

export default class extends Vue {
    @Prop({ required: true }) private content!: string
    @Prop({ required: true }) private changeCb!: Function
    @Prop({ default: true }) private image!: boolean
    @Prop({ default: true }) private link!: boolean
    @Prop({ default: '请输入内容' }) private placeholder!: string
    @Prop({ default: false }) private error!: boolean

    private editor: any = null
    private editorContent: string = ''
    private editorOptions = {
        modules: {
            toolbar: [
                [
                    { header: [1, 2, 3, false] },
                    'bold', 'italic', 'underline'
                ],
                [
                    this.link ? 'link' : undefined, 
                    this.image ? 'image' : undefined
                ],
                [
                    { list: 'ordered' }, 
                    { list: 'bullet' },
                    { align: [] }
                ],
                [
                    { 'indent': '-1' }, 
                    { 'indent': '+1' }
                ],
                ['clean'],
                [{ 'color': [] }, { 'background': [] }], 
                [{ 'font': [] }]
            ]
        },
        clipboard: {
            matchers: [[Node.ELEMENT_NODE, this.handleCustomMatcher ]]
        },
        theme: 'snow',
        placeholder: ''
    }

    /* ---------------------- 分界线 ---------------------- */
    private created() {
        this.editorOptions.placeholder = this.placeholder
    }

    private mounted() {
        this.editorContent = this.content
        // 为图片ICON绑定事件 getModule 为编辑器的内部属性
        const $quillEditor = this.$refs.quillEditor as any
        $quillEditor.quill.getModule('toolbar').addHandler('image', this.onUploadImg)
    }

    private uploadImgCallback(url: string) {
        const $quillEditor = this.$refs.quillEditor as any
        const imgUrl = IMG_HOST + url
        const addRange: any = $quillEditor.quill.getSelection()
        // 调用编辑器的 insertEmbed 方法，插入URL
        $quillEditor.quill.insertEmbed(addRange !== null ? addRange.index : 0, 'image', imgUrl)   
    }

    private onUploadImg(state: boolean) {
        if (state) {
            (this.$refs.uploadImg as any).onUploadImg()
        }
    }

    private onEditorChange($event: any) {
        this.changeCb($event.html)
    }

    private handleCustomMatcher(node: any, delta: any) {
        console.log(delta)
        delta.ops = delta.ops.map((op: any) => {
            return {
                insert: op.insert
            }
        })
        return delta
    }

    @Watch('content')
    onContentChange(val: string) {
        this.editorContent = val
    }
}
